@if (issueForm) {
  <tidy-card>
    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }
    <form [formGroup]="issueForm" novalidate action="#">
      <tidy-row class="extra-bottom-padding">
        <tidy-image
          (click)="close()"
          src="assets/ionic-icon-v3/ios-close.svg"
          class="close-icon title-size" />
      </tidy-row>
      <tidy-row>
        <div class="title-header">
          @if (issue) {
            <tidy-image
              [src]="issueHeaderIcon"
              class="header-size" />
          }
          @if (issue) {
            <tidy-input
              label="Title"
              [icon]="'assets/svg/create.svg'"
              [submitted]="submitted"
              class="title-input"
              [form]="issueForm.get('title')"
              formControlName="title"
            />
          }
          @if (!issue) {
            <tidy-text
              header="Create Issue" />
          }
        </div>
      </tidy-row>
      @if (issue) {
        <tidy-row class="extra-bottom-padding">
          <div class="display-flex">
            <tidy-image
              [src]="'assets/img/clock.svg'"
              class="header-size" />
            <tidy-text
              [helper]="('Reported by ' | translate) + issue.reporter_name + ' @ ' + (issue.created_at | parseDateTime:'MMM d':'local') + ' ' + (issue.created_at | parseDateTime:'h:mma':'local')"
            />
          </div>
        </tidy-row>
      }
      @if (!issue) {
        <tidy-row class="extra-bottom-padding">
          <tidy-input
            label="Title"
            [icon]="'assets/svg/create.svg'"
            [submitted]="submitted"
            [form]="issueForm.get('title')"
            formControlName="title"
          />
        </tidy-row>
      }
      <div class="double-input-row">
        <tidy-select
          label="Status"
          [icon]="'assets/svg/flag.svg'"
          [items]="statusOptions"
          [submitted]="submitted"
          [form]="issueForm.get('status')"
          formControlName="status" />
        <tidy-select
          label="Type"
          [icon]="'assets/svg/list.svg'"
          [items]="issueTypeOptions"
          [submitted]="submitted"
          [form]="issueForm.get('issue_report_type_id')"
          formControlName="issue_report_type_id" />
      </div>
      <div class="double-input-row">
        <tidy-select
          label="Property"
          [icon]="'assets/svg/home.svg'"
          [items]="propertyOptions"
          [submitted]="submitted"
          [form]="issueForm.get('address_id')"
          formControlName="address_id"
        />
        <tidy-select
          label="Priority"
          [icon]="'assets/svg/alert-circle.svg'"
          [items]="urgencyOptions"
          [submitted]="submitted"
          [form]="issueForm.get('urgency')"
          formControlName="urgency" />
      </div>
      <!-- TODO JOBS v3 -->
      <!-- <tidy-row class="extra-bottom-padding">
      <tidy-select
        label="Jobs"
        [items]="[]"
        [form]="issueForm.get('job')"
        formControlName="job"
        (optionChange)="updateJob($event)">
      </tidy-select>
    </tidy-row> -->
    <tidy-row class="extra-bottom-padding">
      <tidy-textarea
        label="Description"
        [icon]="'assets/svg/document-text.svg'"
        [submitted]="submitted"
        [form]="issueForm.get('description')"
        formControlName="description"
      />
    </tidy-row>
    <div class="attachments">
      <tidy-text
        body="Attachments" />
      <tidy-text
        body="Add"
        class="link"
        (click)="$event.stopPropagation()"
        (action)="addAttachment(issue)" />
      @if (reportPhotos?.length) {
        <tidy-row class="field-top-padding">
          <tidy-row>
            <tidy-text
              [body]="'Photos:'" />
          </tidy-row>
          @for (attachment of reportPhotos; track attachment; let i = $index) {
            <tidy-row>
              @if (issue) {
                <tidy-text
                  [actionBody]="attachment.description ?? ('Photo '+ (i+1))"
                  (action)="openAttachment(attachment.photo_url)"
                  class="link" />
              }
              @if (!issue) {
                <tidy-text
                  [body]="attachment.description" />
              }
              <tidy-text
                [actionBody]="'remove'"
                (action)="removeAttachment(i, attachment)"
                class="link red" />
            </tidy-row>
          }
        </tidy-row>
      }
    </div>
    @if (!issue) {
      <tidy-button
        [action]="boundSaveIssue"
        class="primary save-issue-button"
        [text]="'Save'" />
    }
    <div class="add-remove-links">
      @if (issue) {
        <tidy-text
          [body]="'Delete'"
          class="link"
          (action)="deleteIssue(issue)" />
      }
    </div>
  </form>
</tidy-card>
}
